import Model from "@/models/Model"

export default class WhKardex extends Model {

    static includes = [
        "wh_stock_movement",
    ]

    get ini_in_quantity () {
        return this.ini.in_quantity
    }

    get ini_in_cost () {
        return this.ini.in_cost
    } 

    get ini_in_unit_cost () {
        return this.ini.in_unit_cost
    }

    get inventory_inventory_balance_cost () {
        return this.inventory.inventory_balance_cost
    }

    get inventory_inventory_quantity () {
        return this.inventory.inventory_quantity
    }
    
    get inventory_inventory_unit_cost () {
        return this.inventory.inventory_unit_cost
    }

    get out_out_quantity () {
        return this.out.out_quantity
    }

    get out_out_cost () {
        return this.out.out_cost
    }

    get out_out_unit_cost () {
        return this.out.out_unit_cost
    }

    /*get wh_stock_movement_wh_warehouse_movement_reason () {
        return this.wh_stock_movement.wh_warehouse_movement.reason
    }*/

    resource() {
        return "wh_kardex"
    }
}